import { Typography, Box } from "@mui/material";
import { Link } from '@mui/material';           // MUI Link

function CookiesPolicy() {
    return (
        <Box 
            id="cookies-content"
            className="material-container"
            sx={{
                left: 0,
                top: 0,
                overflow: 'auto',
                minHeight: 'auto',
                maxHeight: '100%',
                // backgroundColor: cookiesBackgroundColor,  // Use your theme or state for this
                // height: sizeContentHeight,             // Use your theme or state for this
                // width: sizeContentWidth,              // Use your theme or state for this
            }}
        >
            <Box id="cookies-scroll" className="mat-typography material-container content scrolling" role="main">
                <Box className="card stacked">
                    <Box className="card-content scrolling" sx={{ overflow: 'auto', height: '100%',  }}>
                        <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
                            Cookies Policy
                        </Typography>
                        <Typography variant='h7'>
                            mobidawg, llc
                        </Typography>
                        <h6>
                            Click here to read the <Link href="/src/assets/docs/mobidawg_Privacy_Policy.pdf" target="_blank">full policy</Link>. 
                            Last updated: December 27th 2024
                        </h6>

                        <Typography variant="h3" sx={{ fontSize: '1.2rem', fontWeight: 'bolder' }}>
                            Cookies and Other Technologies
                        </Typography>
                        <Typography variant="body1" sx={{ mb: '1rem' }}>
                            <span id="mobidawg_inline">mobidawg, llc</span> indirectly use cookies as a consequence of using 
                            services (currently, as of October 2009, only Google Adsense) to store information about guests preferences, 
                            record user-specific information on which pages the user access or visit, customize Web page content based on 
                            guests' browser type or other information that the visitor sends via their browser.
                        </Typography>
                        <Typography variant="body1" sx={{ mb: '1rem' }}>
                            Some of our advertising partners may use cookies and web beacons on our site. Our advertising partners currently 
                            only include Google Adsense, however, <span id="mobidawg_inline">mobidawg, llc</span> reserves the right to add or 
                            change advertising publishers without notice or without change to this policy.
                        </Typography>

                        {/* ... (Convert remaining <p> tags to <Typography paragraph>) ... */}

                        <Typography variant="h3" sx={{ fontSize: '1.2rem', fontWeight: 'bolder' }}>
                            What is the DoubleClick DART cookie?
                        </Typography>
                        <Typography variant="body1" sx={{ mb: '1rem' }}>
                            The <Link href="http://www.doubleclick.com/privacy/faq.aspx" target="_blank">DoubleClick DART cookie</Link> is used 
                            by Google in the ads served on the websites of its partners, such as our mobidawg.com website. This is conspicuously 
                            noticeable via the display of AdSense ads or participating in Google certified ad networks. When users visit a 
                            partner's website and either view or click on an ad, a cookie may be dropped on that end user's browser. 
                            Therefore, this is possible when visiting mobidawg.com websites. The data gathered from these cookies will be 
                            used to help better serve and manage <em>meaningful</em> ads on our site(s) as is commonly found across the web.
                        </Typography>
                        <Box>
                            <Typography variant="h4" sx={{ fontSize: '1.1rem', fontWeight: 'bolder' }}>Notice:</Typography>
                            <Typography variant="body1" sx={{ mb: '1rem' }}>
                            Please be aware that users of <span id="mobidawg_inline">mobidawg, llc</span> may opt out of the use of the DART 
                            cookie by visiting Google's website 
                            <Link href="http://www.google.com/privacy_ads.html" title="Google Privacy Center | opt-out" target="_blank">Google ad and content network privacy policy</Link>. 
                            If one has not opted out of "<i>third-party ad serving</i>" 
                            <Link href="http://www.google.com/privacy_ads.html" title="Google Privacy Center | opt-out" target="_blank">(click here to <i>opt-out</i>)</Link>, the cookies 
                            of other third-party vendors or ad networks may also be used to serve ads on our site that you are visiting.
                            </Typography>
                        </Box>
                        <Typography variant="body1" sx={{ mb: '1rem' }}>
                            Therefore, <span id="mobidawg_inline">mobidawg, llc</span> uses third-party advertising companies to serve ads when 
                            you visit our websites. These companies may use information (not including your name, address, email address, or 
                            telephone number) about your visits to this and other websites to provide advertisements about goods and services of 
                            interest to you (i.e., intended to be <em>relevant</em> and <em>meaningful</em>). If you would like more information 
                            about this practice and to know your choices about not having this information used by these companies, 
                            <Link href="http://www.google.com/privacy_ads.html" title="Google's privacy center." target="_blank">click here</Link>.

                        </Typography>

                        <Typography variant="h4" sx={{ fontSize: '1.1rem', fontWeight: 'bolder' }}>Personal Information</Typography>

                        <Typography variant="body1" sx={{ mb: '1rem' }}>
                                    <span id=" mobidawg_inline ">mobidawg.com</span> will only collect personal
                                    information if you voluntarily choose to share such information with us. For
                                    example, to sign up for a newsletter, to register or purchase
                                    products we may require that you furnish personal information.
                            </Typography>
                            <Typography variant="body1" sx={{ mb: '1rem' }}>
                            For your convenience, <span id="mobidawg_inline ">mobidawg.com</span> includes links
                                    to third party sites (see our "Like it sites "). You should carefully review
                                    security/privacy policies of any third party sites
                                    accessible from that particular third party site.
                                </Typography>

                                <Typography variant="h4" sx={{ fontSize: '1.1rem', fontWeight: 'bolder' }}>Anonymous or Aggregated Data</Typography>

                                <Typography variant="body1" sx={{ mb: '1rem' }}>
                                <span id="mobidawg_inline ">mobidawg.com</span> may collect and store certain data
                                    about the use of the Site. This is done on an anonymous basis, and the same
                                    information is collected for all hits on
                                    <span id="mobidawg_inline ">mobidawg.com</span> servers. The information collected
                                    may include the time and date you visited the site, the pages at which you looked
                                    and domain name. We do not link this information
                                    to anything personally identifiable to you. We only use this information for system
                                    administration and to help us develop ideas about how we might improve your visit to
                                    the <span id="mobidawg_inline ">mobidawg.com</span> site.
                                    </Typography>

                                    <Typography variant="h4" sx={{ fontSize: '1.1rem', fontWeight: 'bolder' }}>Log Files</Typography>

                                    <Typography variant="body1" sx={{ mb: '1rem' }}>
                                    Like many other Web sites, <span id="mobidawg_inline ">mobidawg.com</span> makes use
                                    of log files for security, maintenance and various adminstration purposes. The
                                    information inside the log files includes internet
                                    protocol ( IP ) addresses, type of browser, Internet Service Provider ( ISP ),
                                    date/time stamp, referring/exit pages, and number of clicks to analyze trends,
                                    administer the site, track user's movement around the
                                    site, and gather demographic information. IP addresses, and other such information
                                    are not linked to any information that is personally identifiable. Its primary use
                                    is as aggregated data, but can be used for historic
                                    records as may be used in law enforcement forensics. 
                                    </Typography>

                                    <Typography variant="h4" sx={{ fontSize: '1.1rem', fontWeight: 'bolder' }}>Compliance with Applicable Law</Typography>

                                    <Typography variant="body1" sx={{ mb: '1rem' }}>
                                    We may need to collect and retain personal about you in order to comply with
                                    applicable laws and to respond to requests from public authorities, including public
                                    authorities outside your country of residence.
                                    </Typography>
                                    <Typography variant="body1" sx={{ mb: '1rem' }}>
                                    Rest assured that, <span id="mobidawg_inline ">mobidawg.com</span> does not share,
                                    rent or sell your information to other companies in ways other than those disclosed
                                    in this privacy statement.
                                    </Typography>
                                    <Typography variant="body1" sx={{ mb: '1rem' }}>
                                    <span id="mobidawg_inline ">mobidawg.com</span> welcomes your questions and comments
                                    about security and privacy. For any additional information, send an email to
                                    <a id="mailto " href="mailto:privacy@mobidawg.com" 
                                        title="The policy maker responsible for mobidawg 's privacy policy.">privacy&#64;mobidawg.com</a>
                                    </Typography>                                    
                                

                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default CookiesPolicy;
